import type { LauraStageCompletion, LauraStageId } from "@/app/components/shared/types";
import { LAURA_STAGES, stageLabel } from "./stages";

interface Props {
    currentStage: LauraStageId;
    completions: LauraStageCompletion[];
    outputLanguage: string;
    onSelectStage: (stage: LauraStageId) => void;
}

export function LauraStageNavigator({
    currentStage,
    completions,
    outputLanguage,
    onSelectStage,
}: Props) {
    const completed = new Set(completions.map((c) => c.stage));
    const lang = outputLanguage.startsWith("pt") ? "pt" : "en";

    return (
        <div className="border-b bg-gray-50 px-4 py-3 overflow-x-auto">
            <div className="flex gap-1 min-w-max">
                {LAURA_STAGES.map((s) => {
                    const isCurrent = s.id === currentStage;
                    const isDone = completed.has(s.id);
                    const label = stageLabel(s.id, lang);
                    return (
                        <button
                            key={s.id}
                            type="button"
                            onClick={() => onSelectStage(s.id)}
                            className={`shrink-0 rounded-full px-3 py-1 text-xs font-medium transition-colors ${
                                isCurrent
                                    ? "bg-gray-900 text-white"
                                    : isDone
                                      ? "bg-green-100 text-green-800 hover:bg-green-200"
                                      : "bg-white text-gray-600 border hover:bg-gray-100"
                            }`}
                            title={label}
                        >
                            {s.id.toUpperCase()}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
